<template>
<div class="container">
  <div class="row mb--60">
    <div class="col-lg-12 text-center">
      <p class="description description mt--60 mb--60" v-html="thankYouPageContent" />
      <a class="rbt-btn btn-violet btn-xs text-center" :href="this.redirectUrl" rel="nofollow">
        <span data-text="Go to my Dashboard">Go to my Dashboard in {{countDown}}s</span>
      </a>

    </div>
  </div>
</div>
</template>
<script>
export default {
  props: {
    thankYouPageContent: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      redirectUrl : null,
      countDown: 20,
    }
  },
  mounted() {
    this.confirmAffiliate()
    this.getToBackend()
  },
  methods: {
    confirmAffiliate() {

      const affiliateData = localStorage.getItem('affiliate_data') ?? null
      const orderdetails =  localStorage.getItem('orderDetails')
      let formdatas = {
        'orderData': orderdetails,
        'affiliateData': affiliateData,
        'action': 'affiliate_suggest',
      }

      const formdata = this.serialize(formdatas)

      const host = window.location.protocol + "//" + window.location.host;
      fetch( host + '/wp-admin/admin-ajax.php', {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        //make sure to serialize your JSON body
        body: formdata,
      })
          .then( response => response.json() )
          .then(data => {
            console.log(data);
          });
    },
    serialize(obj) {
      let str = [];
      for (let p in obj)
        if (Object.prototype.hasOwnProperty.call(obj, p)) {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
      return str.join("&");
    },
    getToBackend() {
      this.redirectUrl = `${process.env.VUE_APP_WEBSITEURL}/login/${localStorage.accessToken}`
      setTimeout(() => {
        window.location.href = this.redirectUrl
      }, 20000)
    },
    countDownTimer () {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
        }, 1000)
      }
    }
  },
  created () {
    this.countDownTimer()
  }
}
</script>
<style scoped>
  .thankYouPageContent {
    text-align: center
  }
</style>